import { render, staticRenderFns } from "./Topic2PvpAward.vue?vue&type=template&id=0fa68ef4&scoped=true"
import script from "./Topic2PvpAward.vue?vue&type=script&lang=js"
export * from "./Topic2PvpAward.vue?vue&type=script&lang=js"
import style0 from "./Topic2PvpAward.vue?vue&type=style&index=0&id=0fa68ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa68ef4",
  null
  
)

export default component.exports